export default __webpack_public_path__ + "static/media/PTD.54063246.jpg";